var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/apis/login/types.ts
var LoginState = /* @__PURE__ */ ((LoginState2) => {
  LoginState2["LOGIN_REQUIRED"] = "LoginRequired";
  LoginState2["TWO_FACTOR_REQUIRED"] = "TwoFactorRequired";
  LoginState2["EMAIL_NOT_CONFIRMED_YET"] = "ConfirmEmailRequired";
  LoginState2["USER_MISSING_REQUIRED_PROPERTIES"] = "UserMetadataRequired";
  LoginState2["USER_MUST_BE_IN_AT_LEAST_ONE_ORG"] = "OrgCreationRequired";
  LoginState2["UPDATE_PASSWORD_REQUIRED"] = "UpdatePasswordRequired";
  LoginState2["TWO_FACTOR_ENROLLMENT_REQUIRED"] = "TwoFactorEnablementRequired";
  LoginState2["LOGGED_IN"] = "Finished";
  return LoginState2;
})(LoginState || {});

// src/helpers/error_utils.ts
function getVisitorOrUndefined(handler, error) {
  if (handler) {
    return () => handler(error);
  } else {
    return void 0;
  }
}
var unmatchedCase = (x) => {
  throw new Error(`Unmatched case: ${x}`);
};

// src/helpers/errors.ts
var ErrorCode = /* @__PURE__ */ ((ErrorCode2) => {
  ErrorCode2["InvalidRequestFields"] = "invalid_request_fields";
  ErrorCode2["BadRequest"] = "bad_request";
  ErrorCode2["NotFound"] = "not_found";
  ErrorCode2["UserNotFound"] = "user_not_found";
  ErrorCode2["OrgNotFound"] = "org_not_found";
  ErrorCode2["UnexpectedError"] = "unexpected_error";
  ErrorCode2["DbError"] = "db_error";
  ErrorCode2["Unauthorized"] = "not_logged_in";
  ErrorCode2["Forbidden"] = "action_forbidden";
  ErrorCode2["ActionDisabled"] = "action_disabled";
  ErrorCode2["EmailNotConfirmed"] = "email_not_confirmed";
  ErrorCode2["EmailSendFailure"] = "email_send_failure";
  ErrorCode2["UserAccountLocked"] = "account_locked";
  ErrorCode2["ConfirmationEmailAlreadySentRecently"] = "confirmation_email_sent";
  ErrorCode2["IncorrectPassword"] = "incorrect_password";
  ErrorCode2["MaxFileSizeExceeded"] = "max_file_size";
  ErrorCode2["ActionAlreadyComplete"] = "action_already_complete";
  ErrorCode2["OrgMaxUsersLimitExceeded"] = "org_max_users_limit_exceeded";
  ErrorCode2["UserMaxOrgsLimitExceeded"] = "user_max_orgs_limit_exceeded";
  ErrorCode2["PersonalDomainError"] = "personal_domain_error";
  ErrorCode2["UserAccountDisabled"] = "account_disabled";
  ErrorCode2["EmailAlreadyConfirmed"] = "email_already_confirmed";
  ErrorCode2["RateLimited"] = "rate_limit_exceeded";
  ErrorCode2["InvalidMfaCookie"] = "invalid_mfa_cookie";
  ErrorCode2["UserAccountMfaLocked"] = "account_mfa_locked";
  ErrorCode2["IncorrectMfaCode"] = "incorrect_mfa_code";
  ErrorCode2["DomainNotAllowed"] = "domain_not_allowed";
  return ErrorCode2;
})(ErrorCode || {});

// src/helpers/request.ts
var BASE_PATH = "/api/fe/v3";
var makeRequest = (args) => __async(void 0, null, function* () {
  const {
    authUrl,
    parseResponseAsJson,
    method,
    body,
    path,
    queryParams,
    responseToSuccessHandler,
    responseToErrorHandler
  } = args;
  const url = `${authUrl}${BASE_PATH}${path}${queryParams ? `?${queryParams.toString()}` : ""}`;
  try {
    const response = yield fetch(url, {
      method,
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": "-.-"
      },
      body: body ? JSON.stringify(body) : void 0
    });
    if (response.ok) {
      if (parseResponseAsJson) {
        const jsonResponse = yield response.json();
        return {
          ok: true,
          data: jsonResponse,
          handle: (visitor) => {
            const handler = responseToSuccessHandler(jsonResponse, visitor);
            return handler();
          }
        };
      } else {
        return {
          ok: true,
          data: void 0,
          handle: (visitor) => {
            const handler = responseToSuccessHandler(visitor);
            return handler();
          }
        };
      }
    } else {
      const error = yield response.json();
      return {
        ok: false,
        error,
        handle: (visitor) => {
          const handler = responseToErrorHandler(error, visitor);
          if (handler) {
            return handler();
          } else if (visitor.unexpectedOrUnhandled) {
            return visitor.unexpectedOrUnhandled(error);
          } else {
            console.error(`No error handler for: ${error.error_code}`);
          }
        }
      };
    }
  } catch (e) {
    const unexpectedError = {
      error_code: "unexpected_error" /* UnexpectedError */,
      user_facing_error: "An unexpected error has occurred"
    };
    return {
      ok: false,
      error: unexpectedError,
      handle: (visitor) => {
        if (visitor.unexpectedOrUnhandled) {
          return visitor.unexpectedOrUnhandled(unexpectedError);
        } else {
          console.error(`No error handler for: ${unexpectedError.error_code}`);
        }
      }
    };
  }
});

// src/apis/apiKeys/createOrgApiKey.ts
var createOrgApiKey = (authUrl) => (orgId, expirationOption) => __async(void 0, null, function* () {
  return makeRequest({
    authUrl,
    path: "/api_keys",
    method: "POST",
    parseResponseAsJson: true,
    body: {
      org_id: orgId,
      expiration_option: expirationOption
    },
    responseToSuccessHandler: (response, visitor) => {
      return () => visitor.success(response);
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "action_forbidden" /* Forbidden */:
          return getVisitorOrUndefined(visitor.noOrgApiKeyPermission, error);
        case "bad_request" /* BadRequest */:
          return getVisitorOrUndefined(visitor.invalidExpirationOption, error);
        case "not_logged_in" /* Unauthorized */:
          return getVisitorOrUndefined(visitor.unauthorized, error);
        case "email_not_confirmed" /* EmailNotConfirmed */:
          return getVisitorOrUndefined(visitor.emailNotConfirmed, error);
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/apis/apiKeys/createPersonalApiKey.ts
var createPersonalApiKey = (authUrl) => (expirationOption) => __async(void 0, null, function* () {
  return makeRequest({
    authUrl,
    path: "/api_keys",
    method: "POST",
    parseResponseAsJson: true,
    body: {
      expiration_option: expirationOption
    },
    responseToSuccessHandler: (response, visitor) => {
      return () => visitor.success(response);
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "action_forbidden" /* Forbidden */:
          return getVisitorOrUndefined(visitor.noPersonalApiKeyPermission, error);
        case "bad_request" /* BadRequest */:
          return getVisitorOrUndefined(visitor.invalidExpirationOption, error);
        case "not_logged_in" /* Unauthorized */:
          return getVisitorOrUndefined(visitor.unauthorized, error);
        case "email_not_confirmed" /* EmailNotConfirmed */:
          return getVisitorOrUndefined(visitor.emailNotConfirmed, error);
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/apis/apiKeys/deleteApiKey.ts
var deleteApiKey = (authUrl) => (apiKeyId) => __async(void 0, null, function* () {
  return makeRequest({
    authUrl,
    path: `/api_keys/${apiKeyId}`,
    method: "DELETE",
    responseToSuccessHandler: (visitor) => {
      return () => visitor.success();
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "action_forbidden" /* Forbidden */:
          return getVisitorOrUndefined(visitor.noApiKeyPermission, error);
        case "not_logged_in" /* Unauthorized */:
          return getVisitorOrUndefined(visitor.unauthorized, error);
        case "email_not_confirmed" /* EmailNotConfirmed */:
          return getVisitorOrUndefined(visitor.emailNotConfirmed, error);
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        case "not_found" /* NotFound */:
          return getVisitorOrUndefined(visitor.apiKeyNotFound, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/apis/apiKeys/fetchOrgApiKeys.ts
var fetchOrgApiKeys = (authUrl) => (request) => __async(void 0, null, function* () {
  const queryParams = new URLSearchParams();
  const { page_number, page_size, api_key_search } = request;
  queryParams.append("org_id", request.org_id);
  if (page_number) {
    queryParams.append("page_number", page_number.toString());
  }
  if (page_size) {
    queryParams.append("page_size", page_size.toString());
  }
  if (api_key_search) {
    queryParams.append("api_key_search", api_key_search);
  }
  return makeRequest({
    authUrl,
    path: "/org_api_keys",
    method: "GET",
    parseResponseAsJson: true,
    queryParams,
    responseToSuccessHandler: (response, visitor) => {
      return () => visitor.success(response);
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "not_logged_in" /* Unauthorized */:
          return getVisitorOrUndefined(visitor.unauthorized, error);
        case "email_not_confirmed" /* EmailNotConfirmed */:
          return getVisitorOrUndefined(visitor.emailNotConfirmed, error);
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        case "action_forbidden" /* Forbidden */:
          return getVisitorOrUndefined(visitor.cannotAccessOrgApiKeys, error);
        case "invalid_request_fields" /* InvalidRequestFields */:
          return getVisitorOrUndefined(visitor.badRequest, error);
        case "org_not_found" /* OrgNotFound */:
          return getVisitorOrUndefined(visitor.orgNotFound, error);
        case "action_disabled" /* ActionDisabled */:
          return getVisitorOrUndefined(visitor.orgApiKeysDisabled, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/apis/apiKeys/fetchPersonalApiKeys.ts
var fetchPersonalApiKeys = (authUrl) => (request) => __async(void 0, null, function* () {
  const queryParams = new URLSearchParams();
  const { page_number, page_size, api_key_search } = request;
  if (page_number) {
    queryParams.append("page_number", page_number.toString());
  }
  if (page_size) {
    queryParams.append("page_size", page_size.toString());
  }
  if (api_key_search) {
    queryParams.append("api_key_search", api_key_search);
  }
  return makeRequest({
    authUrl,
    path: "/personal_api_keys",
    method: "GET",
    parseResponseAsJson: true,
    queryParams,
    responseToSuccessHandler: (response, visitor) => {
      return () => visitor.success(response);
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "not_logged_in" /* Unauthorized */:
          return getVisitorOrUndefined(visitor.unauthorized, error);
        case "email_not_confirmed" /* EmailNotConfirmed */:
          return getVisitorOrUndefined(visitor.emailNotConfirmed, error);
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        case "action_disabled" /* ActionDisabled */:
          return getVisitorOrUndefined(visitor.personalApiKeysDisabled, error);
        case "invalid_request_fields" /* InvalidRequestFields */:
          return getVisitorOrUndefined(visitor.badRequest, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/apis/createOrg.ts
var createOrg = (authUrl) => (request) => __async(void 0, null, function* () {
  var _a, _b;
  const internalRequest = {
    name: request.name,
    autojoin_by_domain: (_a = request.allow_users_to_join_by_domain) != null ? _a : false,
    restrict_to_domain: (_b = request.restrict_invites_by_domain) != null ? _b : false
  };
  return makeRequest({
    authUrl,
    path: "/create_org",
    parseResponseAsJson: true,
    method: "POST",
    body: internalRequest,
    responseToSuccessHandler: (response, visitor) => {
      return () => visitor.success(response);
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "invalid_request_fields" /* InvalidRequestFields */:
          return getVisitorOrUndefined(visitor.badRequest, error);
        case "action_disabled" /* ActionDisabled */:
          return getVisitorOrUndefined(visitor.cannotCreateOrgs, error);
        case "personal_domain_error" /* PersonalDomainError */:
          return getVisitorOrUndefined(visitor.cannotUsePersonalDomain, error);
        case "user_max_orgs_limit_exceeded" /* UserMaxOrgsLimitExceeded */:
          return getVisitorOrUndefined(visitor.userAlreadyInTooManyOrgs, error);
        case "not_logged_in" /* Unauthorized */:
          return getVisitorOrUndefined(visitor.unauthorized, error);
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        case "email_not_confirmed" /* EmailNotConfirmed */:
          return getVisitorOrUndefined(visitor.emailNotConfirmed, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/apis/deleteAccount.ts
var deleteAccount = (authUrl) => () => __async(void 0, null, function* () {
  return makeRequest({
    authUrl,
    path: "/delete_me",
    method: "DELETE",
    responseToSuccessHandler: (visitor) => {
      return () => visitor.success();
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "action_disabled" /* ActionDisabled */:
          return getVisitorOrUndefined(visitor.actionDisabled, error);
        case "not_logged_in" /* Unauthorized */:
          return getVisitorOrUndefined(visitor.unauthorized, error);
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/apis/deleteOrg.ts
var deleteOrg = (authUrl) => (orgId) => __async(void 0, null, function* () {
  return makeRequest({
    authUrl,
    path: "/delete_org",
    method: "DELETE",
    body: { org_id: orgId },
    responseToSuccessHandler: (visitor) => {
      return () => visitor.success();
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "action_disabled" /* ActionDisabled */:
          return getVisitorOrUndefined(visitor.actionDisabled, error);
        case "not_logged_in" /* Unauthorized */:
          return getVisitorOrUndefined(visitor.unauthorized, error);
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        case "org_not_found" /* OrgNotFound */:
          return getVisitorOrUndefined(visitor.orgNotFound, error);
        case "action_forbidden" /* Forbidden */:
          return getVisitorOrUndefined(visitor.noDeletePermission, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/apis/fetchOrgSettings.ts
var fetchOrgSettings = (authUrl) => (orgId) => __async(void 0, null, function* () {
  return makeRequest({
    authUrl,
    path: `/org_settings?org_id=${orgId}`,
    method: "GET",
    parseResponseAsJson: true,
    responseToSuccessHandler: (response, visitor) => {
      return () => visitor.success(response);
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "action_disabled" /* ActionDisabled */:
          return getVisitorOrUndefined(visitor.orgsNotEnabled, error);
        case "org_not_found" /* OrgNotFound */:
          return getVisitorOrUndefined(visitor.orgNotFound, error);
        case "not_logged_in" /* Unauthorized */:
          return getVisitorOrUndefined(visitor.unauthorized, error);
        case "email_not_confirmed" /* EmailNotConfirmed */:
          return getVisitorOrUndefined(visitor.emailNotConfirmed, error);
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/apis/inviteUserToOrg.ts
var inviteUserToOrg = (authUrl) => (request) => __async(void 0, null, function* () {
  var _a;
  return makeRequest({
    authUrl,
    path: "/invite_user",
    method: "POST",
    body: __spreadProps(__spreadValues({}, request), {
      additional_roles: (_a = request.additional_roles) != null ? _a : []
    }),
    responseToSuccessHandler: (visitor) => {
      return () => visitor.success();
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "invalid_request_fields" /* InvalidRequestFields */:
          return getVisitorOrUndefined(visitor.badRequest, error);
        case "action_forbidden" /* Forbidden */:
          return getVisitorOrUndefined(visitor.noInvitePermission, error);
        case "org_not_found" /* OrgNotFound */:
          return getVisitorOrUndefined(visitor.orgNotFound, error);
        case "org_max_users_limit_exceeded" /* OrgMaxUsersLimitExceeded */:
          return getVisitorOrUndefined(visitor.orgMaxUsersLimitExceeded, error);
        case "action_already_complete" /* ActionAlreadyComplete */:
          return getVisitorOrUndefined(visitor.userAlreadyInOrg, error);
        case "action_disabled" /* ActionDisabled */:
          return getVisitorOrUndefined(visitor.orgsNotEnabled, error);
        case "not_logged_in" /* Unauthorized */:
          return getVisitorOrUndefined(visitor.unauthorized, error);
        case "email_not_confirmed" /* EmailNotConfirmed */:
          return getVisitorOrUndefined(visitor.emailNotConfirmed, error);
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/apis/joinOrg.ts
var joinOrg = (authUrl) => (orgId) => __async(void 0, null, function* () {
  return makeRequest({
    authUrl,
    path: `/join_org/${orgId}`,
    parseResponseAsJson: true,
    method: "POST",
    responseToSuccessHandler: (response, visitor) => {
      return () => visitor.success(response);
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "org_max_users_limit_exceeded" /* OrgMaxUsersLimitExceeded */:
          return getVisitorOrUndefined(visitor.orgMaxUsersLimitExceeded, error);
        case "user_max_orgs_limit_exceeded" /* UserMaxOrgsLimitExceeded */:
          return getVisitorOrUndefined(visitor.userAlreadyInTooManyOrgs, error);
        case "not_logged_in" /* Unauthorized */:
          return getVisitorOrUndefined(visitor.unauthorized, error);
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        case "email_not_confirmed" /* EmailNotConfirmed */:
          return getVisitorOrUndefined(visitor.emailNotConfirmed, error);
        case "action_disabled" /* ActionDisabled */:
          return getVisitorOrUndefined(visitor.orgsNotEnabled, error);
        case "org_not_found" /* OrgNotFound */:
          return getVisitorOrUndefined(visitor.orgNotFound, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/apis/login/emailPasswordLogin.ts
var emailPasswordLogin = (authUrl) => (request) => __async(void 0, null, function* () {
  return makeRequest({
    authUrl,
    path: "/login",
    method: "POST",
    body: request,
    parseResponseAsJson: true,
    responseToSuccessHandler: (response, visitor) => {
      return () => visitor.success(response);
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "invalid_request_fields" /* InvalidRequestFields */:
          return getVisitorOrUndefined(visitor.badRequest, error);
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        case "action_disabled" /* ActionDisabled */:
          return getVisitorOrUndefined(visitor.passwordLoginDisabled, error);
        case "account_disabled" /* UserAccountDisabled */:
          return getVisitorOrUndefined(visitor.userAccountDisabled, error);
        case "account_locked" /* UserAccountLocked */:
          return getVisitorOrUndefined(visitor.userAccountLocked, error);
        case "user_not_found" /* UserNotFound */:
          return getVisitorOrUndefined(visitor.invalidCredentials, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/apis/login/fetchLoginState.ts
var fetchLoginState = (authUrl) => () => __async(void 0, null, function* () {
  return makeRequest({
    authUrl,
    path: "/login_state",
    method: "GET",
    parseResponseAsJson: true,
    responseToSuccessHandler: (response, visitor) => {
      return () => visitor.success(response);
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/apis/login/forgotPassword.ts
var sendForgotPasswordEmail = (authUrl) => (request) => __async(void 0, null, function* () {
  return makeRequest({
    authUrl,
    path: "/forgot_password",
    method: "POST",
    body: request,
    parseResponseAsJson: true,
    responseToSuccessHandler: (response, visitor) => {
      return () => visitor.success(response);
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "invalid_request_fields" /* InvalidRequestFields */:
          return getVisitorOrUndefined(visitor.badRequest, error);
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/apis/login/mfaLogin.ts
var verifyMfaForLogin = (authUrl) => (request) => __async(void 0, null, function* () {
  return makeRequest({
    authUrl,
    path: "/verify",
    method: "POST",
    body: request,
    parseResponseAsJson: true,
    responseToSuccessHandler: (response, visitor) => {
      return () => visitor.success(response);
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "invalid_request_fields" /* InvalidRequestFields */:
          return getVisitorOrUndefined(visitor.badRequest, error);
        case "invalid_mfa_cookie" /* InvalidMfaCookie */:
          return getVisitorOrUndefined(visitor.mfaCookieTimeout, error);
        case "account_mfa_locked" /* UserAccountMfaLocked */:
          return getVisitorOrUndefined(visitor.accountLocked, error);
        case "account_disabled" /* UserAccountDisabled */:
          return getVisitorOrUndefined(visitor.accountDisabled, error);
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/apis/login/mfaLoginBackupCode.ts
var verifyMfaBackupCodeForLogin = (authUrl) => (request) => __async(void 0, null, function* () {
  return makeRequest({
    authUrl,
    path: "/verify_backup",
    method: "POST",
    body: request,
    parseResponseAsJson: true,
    responseToSuccessHandler: (response, visitor) => {
      return () => visitor.success(response);
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "invalid_mfa_cookie" /* InvalidMfaCookie */:
          return getVisitorOrUndefined(visitor.mfaCookieTimeout, error);
        case "account_mfa_locked" /* UserAccountMfaLocked */:
          return getVisitorOrUndefined(visitor.accountLocked, error);
        case "account_disabled" /* UserAccountDisabled */:
          return getVisitorOrUndefined(visitor.accountDisabled, error);
        case "incorrect_mfa_code" /* IncorrectMfaCode */:
          return getVisitorOrUndefined(visitor.invalidCode, error);
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/apis/login/passwordlessLogin.ts
var passwordlessLogin = (authUrl) => (request) => __async(void 0, null, function* () {
  return makeRequest({
    authUrl,
    path: "/login_passwordless",
    method: "POST",
    body: request,
    responseToSuccessHandler: (visitor) => {
      return () => visitor.success();
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "invalid_request_fields" /* InvalidRequestFields */:
          return getVisitorOrUndefined(visitor.badRequest, error);
        case "not_found" /* NotFound */:
          return getVisitorOrUndefined(visitor.passwordlessLoginDisabled, error);
        case "bad_request" /* BadRequest */:
          return getVisitorOrUndefined(visitor.cannotSignupWithPersonalEmail, error);
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        case "domain_not_allowed" /* DomainNotAllowed */:
          return getVisitorOrUndefined(visitor.domainNotAllowed, error);
        case "account_disabled" /* UserAccountDisabled */:
          return getVisitorOrUndefined(visitor.userAccountDisabled, error);
        case "account_locked" /* UserAccountLocked */:
          return getVisitorOrUndefined(visitor.userAccountLocked, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/apis/login/resendEmailConfirmation.ts
var resendEmailConfirmation = (authUrl) => () => __async(void 0, null, function* () {
  return makeRequest({
    authUrl,
    path: "/resend_email_confirmation",
    method: "POST",
    responseToSuccessHandler: (visitor) => {
      return () => visitor.success();
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "email_already_confirmed" /* EmailAlreadyConfirmed */:
          return getVisitorOrUndefined(visitor.emailAlreadyConfirmed, error);
        case "rate_limit_exceeded" /* RateLimited */:
          return getVisitorOrUndefined(visitor.rateLimited, error);
        case "not_logged_in" /* Unauthorized */:
          return getVisitorOrUndefined(visitor.unauthorized, error);
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/apis/login/loginViaSamlForOrg.ts
var loginViaSamlForOrg = (authUrl) => (request) => __async(void 0, null, function* () {
  const queryParams = new URLSearchParams();
  if ("domain" in request) {
    queryParams.append("domain", request.domain);
  } else if ("org_id" in request) {
    queryParams.append("org_id", request.org_id);
  } else {
    queryParams.append("email", request.email);
  }
  return makeRequest({
    authUrl,
    path: "/login/check",
    method: "GET",
    queryParams,
    parseResponseAsJson: true,
    responseToSuccessHandler: (response, visitor) => {
      return () => {
        window.location.href = response.login_url;
        visitor.success(response);
      };
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        case "org_not_found" /* OrgNotFound */:
          return getVisitorOrUndefined(visitor.orgNotFound, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/apis/mfa/disableMfa.ts
var disableMfa = (authUrl) => () => __async(void 0, null, function* () {
  return makeRequest({
    authUrl,
    path: "/mfa_disable",
    method: "POST",
    responseToSuccessHandler: (visitor) => {
      return () => __async(void 0, null, function* () {
        return yield visitor.success();
      });
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "action_already_complete" /* ActionAlreadyComplete */:
          return getVisitorOrUndefined(visitor.alreadyDisabled, error);
        case "not_logged_in" /* Unauthorized */:
          return getVisitorOrUndefined(visitor.unauthorized, error);
        case "email_not_confirmed" /* EmailNotConfirmed */:
          return getVisitorOrUndefined(visitor.emailNotConfirmed, error);
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/apis/mfa/enableMfa.ts
var enableMfa = (authUrl) => (request) => __async(void 0, null, function* () {
  return makeRequest({
    authUrl,
    path: "/mfa_enable",
    method: "POST",
    body: request,
    responseToSuccessHandler: (visitor) => {
      return () => visitor.success();
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "invalid_request_fields" /* InvalidRequestFields */:
          return getVisitorOrUndefined(visitor.badRequest, error);
        case "action_already_complete" /* ActionAlreadyComplete */:
          return getVisitorOrUndefined(visitor.alreadyEnabled, error);
        case "not_logged_in" /* Unauthorized */:
          return getVisitorOrUndefined(visitor.unauthorized, error);
        case "email_not_confirmed" /* EmailNotConfirmed */:
          return getVisitorOrUndefined(visitor.emailNotConfirmed, error);
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/apis/mfa/mfaStatus.ts
var fetchMfaStatusWithNewSecret = (authUrl) => () => __async(void 0, null, function* () {
  return yield makeRequest({
    authUrl,
    path: "/security_status",
    method: "POST",
    parseResponseAsJson: true,
    responseToSuccessHandler: (response, visitor) => {
      return () => visitor.success(response);
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "not_logged_in" /* Unauthorized */:
          return getVisitorOrUndefined(visitor.unauthorized, error);
        case "email_not_confirmed" /* EmailNotConfirmed */:
          return getVisitorOrUndefined(visitor.emailNotConfirmed, error);
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/apis/orgMembership/fetchExpiredInvites.ts
var fetchExpiredOrgInvites = (authUrl) => (orgId, params) => __async(void 0, null, function* () {
  const queryParams = new URLSearchParams();
  if (params == null ? void 0 : params.page_size) {
    queryParams.append("page_size", params.page_size.toString());
  }
  if (params == null ? void 0 : params.page_number) {
    queryParams.append("page_number", params.page_number.toString());
  }
  if (params == null ? void 0 : params.email_search) {
    queryParams.append("email_search", params.email_search);
  }
  return makeRequest({
    authUrl,
    path: `/org_membership/${orgId}/expired_invites`,
    method: "GET",
    queryParams,
    parseResponseAsJson: true,
    responseToSuccessHandler: (response, visitor) => {
      return () => visitor.success(response);
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "org_not_found" /* OrgNotFound */:
          return getVisitorOrUndefined(visitor.orgNotFound, error);
        case "action_disabled" /* ActionDisabled */:
          return getVisitorOrUndefined(visitor.orgsNotEnabled, error);
        case "not_logged_in" /* Unauthorized */:
          return getVisitorOrUndefined(visitor.unauthorized, error);
        case "email_not_confirmed" /* EmailNotConfirmed */:
          return getVisitorOrUndefined(visitor.emailNotConfirmed, error);
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/apis/orgMembership/fetchJoinableOrgs.ts
var fetchJoinableOrgs = (authUrl) => () => __async(void 0, null, function* () {
  return makeRequest({
    authUrl,
    path: `/joinable_orgs`,
    method: "GET",
    parseResponseAsJson: true,
    responseToSuccessHandler: (response, visitor) => {
      return () => visitor.success(response);
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "action_disabled" /* ActionDisabled */:
          return getVisitorOrUndefined(visitor.orgsNotEnabled, error);
        case "not_logged_in" /* Unauthorized */:
          return getVisitorOrUndefined(visitor.unauthorized, error);
        case "email_not_confirmed" /* EmailNotConfirmed */:
          return getVisitorOrUndefined(visitor.emailNotConfirmed, error);
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/apis/orgMembership/fetchOrgMembers.ts
var fetchOrgMembers = (authUrl) => (orgId, params) => __async(void 0, null, function* () {
  const queryParams = new URLSearchParams();
  if (params == null ? void 0 : params.page_size) {
    queryParams.append("page_size", params.page_size.toString());
  }
  if (params == null ? void 0 : params.page_number) {
    queryParams.append("page_number", params.page_number.toString());
  }
  if (params == null ? void 0 : params.email_search) {
    queryParams.append("email_search", params.email_search);
  }
  return makeRequest({
    authUrl,
    path: `/org_membership/${orgId}/members`,
    method: "GET",
    parseResponseAsJson: true,
    queryParams,
    responseToSuccessHandler: (response, visitor) => {
      return () => visitor.success(response);
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "org_not_found" /* OrgNotFound */:
          return getVisitorOrUndefined(visitor.orgNotFound, error);
        case "action_disabled" /* ActionDisabled */:
          return getVisitorOrUndefined(visitor.orgsNotEnabled, error);
        case "not_logged_in" /* Unauthorized */:
          return getVisitorOrUndefined(visitor.unauthorized, error);
        case "email_not_confirmed" /* EmailNotConfirmed */:
          return getVisitorOrUndefined(visitor.emailNotConfirmed, error);
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/apis/orgMembership/fetchPendingInvites.ts
var fetchPendingOrgInvites = (authUrl) => (orgId, params) => __async(void 0, null, function* () {
  const queryParams = new URLSearchParams();
  if (params == null ? void 0 : params.page_size) {
    queryParams.append("page_size", params.page_size.toString());
  }
  if (params == null ? void 0 : params.page_number) {
    queryParams.append("page_number", params.page_number.toString());
  }
  if (params == null ? void 0 : params.email_search) {
    queryParams.append("email_search", params.email_search);
  }
  return makeRequest({
    authUrl,
    path: `/org_membership/${orgId}/pending_invites`,
    method: "GET",
    queryParams,
    parseResponseAsJson: true,
    responseToSuccessHandler: (response, visitor) => {
      return () => visitor.success(response);
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "org_not_found" /* OrgNotFound */:
          return getVisitorOrUndefined(visitor.orgNotFound, error);
        case "action_disabled" /* ActionDisabled */:
          return getVisitorOrUndefined(visitor.orgsNotEnabled, error);
        case "not_logged_in" /* Unauthorized */:
          return getVisitorOrUndefined(visitor.unauthorized, error);
        case "email_not_confirmed" /* EmailNotConfirmed */:
          return getVisitorOrUndefined(visitor.emailNotConfirmed, error);
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/apis/removeUserFromOrg.ts
var removeUserFromOrg = (authUrl) => (request) => __async(void 0, null, function* () {
  return makeRequest({
    authUrl,
    path: "/remove_user",
    method: "POST",
    body: request,
    responseToSuccessHandler: (visitor) => {
      return () => visitor.success();
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "invalid_request_fields" /* InvalidRequestFields */:
          return getVisitorOrUndefined(visitor.mustBeAtLeastOneOwner, error);
        case "action_forbidden" /* Forbidden */:
          return getVisitorOrUndefined(visitor.noRemovePermission, error);
        case "org_not_found" /* OrgNotFound */:
          return getVisitorOrUndefined(visitor.orgNotFound, error);
        case "user_not_found" /* UserNotFound */:
          return getVisitorOrUndefined(visitor.userNotFoundInOrg, error);
        case "action_disabled" /* ActionDisabled */:
          return getVisitorOrUndefined(visitor.orgsNotEnabled, error);
        case "not_logged_in" /* Unauthorized */:
          return getVisitorOrUndefined(visitor.unauthorized, error);
        case "email_not_confirmed" /* EmailNotConfirmed */:
          return getVisitorOrUndefined(visitor.emailNotConfirmed, error);
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/apis/revokeUserOrgInvitation.ts
var revokeUserOrgInvitation = (authUrl) => (request) => __async(void 0, null, function* () {
  return makeRequest({
    authUrl,
    path: "/revoke_user_invitation",
    method: "POST",
    body: request,
    responseToSuccessHandler: (visitor) => {
      return () => visitor.success();
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "invalid_request_fields" /* InvalidRequestFields */:
          return getVisitorOrUndefined(visitor.badRequest, error);
        case "action_forbidden" /* Forbidden */:
          return getVisitorOrUndefined(visitor.noRevokeInvitePermission, error);
        case "org_not_found" /* OrgNotFound */:
          return getVisitorOrUndefined(visitor.orgNotFound, error);
        case "action_disabled" /* ActionDisabled */:
          return getVisitorOrUndefined(visitor.orgsNotEnabled, error);
        case "not_logged_in" /* Unauthorized */:
          return getVisitorOrUndefined(visitor.unauthorized, error);
        case "email_not_confirmed" /* EmailNotConfirmed */:
          return getVisitorOrUndefined(visitor.emailNotConfirmed, error);
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/apis/signup.ts
var signup = (authUrl) => (request) => __async(void 0, null, function* () {
  return makeRequest({
    authUrl,
    path: `/signup`,
    parseResponseAsJson: true,
    method: "POST",
    body: request,
    responseToSuccessHandler: (response, visitor) => {
      return () => visitor.success(response);
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "invalid_request_fields" /* InvalidRequestFields */:
          return getVisitorOrUndefined(visitor.badRequest, error);
        case "action_disabled" /* ActionDisabled */:
          return getVisitorOrUndefined(visitor.signupDisabled, error);
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/apis/updateEmail.ts
var updateEmail = (authUrl) => (request) => __async(void 0, null, function* () {
  return makeRequest({
    authUrl,
    path: "/update_email",
    method: "POST",
    body: request,
    responseToSuccessHandler: (visitor) => {
      return () => visitor.success();
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "invalid_request_fields" /* InvalidRequestFields */:
          return getVisitorOrUndefined(visitor.badRequest, error);
        case "action_forbidden" /* Forbidden */:
          return getVisitorOrUndefined(visitor.cannotChangeEmailDueToOrgMembership, error);
        case "confirmation_email_sent" /* ConfirmationEmailAlreadySentRecently */:
          return getVisitorOrUndefined(visitor.rateLimit, error);
        case "action_disabled" /* ActionDisabled */:
          return getVisitorOrUndefined(visitor.emailChangeDisabled, error);
        case "incorrect_password" /* IncorrectPassword */:
          return getVisitorOrUndefined(visitor.incorrectPassword, error);
        case "email_send_failure" /* EmailSendFailure */:
          return getVisitorOrUndefined(visitor.failedToSendEmail, error);
        case "account_locked" /* UserAccountLocked */:
          return getVisitorOrUndefined(visitor.userAccountLocked, error);
        case "not_logged_in" /* Unauthorized */:
          return getVisitorOrUndefined(visitor.unauthorized, error);
        case "email_not_confirmed" /* EmailNotConfirmed */:
          return getVisitorOrUndefined(visitor.emailNotConfirmed, error);
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/apis/updateOrgSettings.ts
var updateOrgSettings = (authUrl) => (request) => __async(void 0, null, function* () {
  const internalRequest = {
    org_id: request.org_id,
    name: request.name,
    autojoin_by_domain: request.allow_users_to_join_by_domain,
    restrict_to_domain: request.restrict_invites_by_domain,
    require_2fa_by: request.require_2fa_by
  };
  return makeRequest({
    authUrl,
    path: "/update_org_metadata",
    method: "POST",
    body: internalRequest,
    responseToSuccessHandler: (visitor) => {
      return () => visitor.success();
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "invalid_request_fields" /* InvalidRequestFields */:
          return getVisitorOrUndefined(visitor.badRequest, error);
        case "action_disabled" /* ActionDisabled */:
          return getVisitorOrUndefined(visitor.orgsNotEnabled, error);
        case "org_not_found" /* OrgNotFound */:
          return getVisitorOrUndefined(visitor.orgNotFound, error);
        case "action_forbidden" /* Forbidden */:
          return getVisitorOrUndefined(visitor.forbidden, error);
        case "not_logged_in" /* Unauthorized */:
          return getVisitorOrUndefined(visitor.unauthorized, error);
        case "email_not_confirmed" /* EmailNotConfirmed */:
          return getVisitorOrUndefined(visitor.emailNotConfirmed, error);
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/apis/updatePassword.ts
var updatePassword = (authUrl) => (request) => __async(void 0, null, function* () {
  return makeRequest({
    authUrl,
    path: "/update_password",
    method: "POST",
    body: request,
    responseToSuccessHandler: (visitor) => {
      return () => visitor.success();
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "incorrect_password" /* IncorrectPassword */:
          return getVisitorOrUndefined(visitor.incorrectPassword, error);
        case "invalid_request_fields" /* InvalidRequestFields */:
          return getVisitorOrUndefined(visitor.badRequest, error);
        case "not_logged_in" /* Unauthorized */:
          return getVisitorOrUndefined(visitor.unauthorized, error);
        case "account_locked" /* UserAccountLocked */:
          return getVisitorOrUndefined(visitor.userAccountLocked, error);
        case "email_not_confirmed" /* EmailNotConfirmed */:
          return getVisitorOrUndefined(visitor.emailNotConfirmed, error);
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/apis/updateUserMetadata.ts
var updateUserMetadata = (authUrl) => (request) => __async(void 0, null, function* () {
  return makeRequest({
    authUrl,
    path: "/update_metadata",
    method: "POST",
    body: request,
    responseToSuccessHandler: (visitor) => {
      return () => visitor.success();
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "invalid_request_fields" /* InvalidRequestFields */:
          return getVisitorOrUndefined(visitor.badRequest, error);
        case "not_logged_in" /* Unauthorized */:
          return getVisitorOrUndefined(visitor.unauthorized, error);
        case "email_not_confirmed" /* EmailNotConfirmed */:
          return getVisitorOrUndefined(visitor.emailNotConfirmed, error);
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/apis/updateUserRoleInOrg.ts
var updateUserRoleInOrg = (authUrl) => (request) => __async(void 0, null, function* () {
  var _a;
  return makeRequest({
    authUrl,
    path: "/change_role",
    method: "POST",
    body: __spreadProps(__spreadValues({}, request), {
      additional_roles: (_a = request.additional_roles) != null ? _a : []
    }),
    responseToSuccessHandler: (visitor) => {
      return () => visitor.success();
    },
    responseToErrorHandler: (error, visitor) => {
      const { error_code: errorCode } = error;
      switch (errorCode) {
        case "invalid_request_fields" /* InvalidRequestFields */:
          return getVisitorOrUndefined(visitor.badRequest, error);
        case "action_forbidden" /* Forbidden */:
          return getVisitorOrUndefined(visitor.noUpdateRolePermission, error);
        case "user_not_found" /* UserNotFound */:
          return getVisitorOrUndefined(visitor.userNotFoundInOrg, error);
        case "action_disabled" /* ActionDisabled */:
          return getVisitorOrUndefined(visitor.orgsNotEnabled, error);
        case "not_logged_in" /* Unauthorized */:
          return getVisitorOrUndefined(visitor.unauthorized, error);
        case "email_not_confirmed" /* EmailNotConfirmed */:
          return getVisitorOrUndefined(visitor.emailNotConfirmed, error);
        case "unexpected_error" /* UnexpectedError */:
          return getVisitorOrUndefined(visitor.unexpectedOrUnhandled, error);
        default:
          unmatchedCase(errorCode);
          return void 0;
      }
    }
  });
});

// src/socialLogins.ts
var SocialLoginProvider = /* @__PURE__ */ ((SocialLoginProvider3) => {
  SocialLoginProvider3["GOOGLE"] = "Google";
  SocialLoginProvider3["GITHUB"] = "Github";
  SocialLoginProvider3["MICROSOFT"] = "Microsoft";
  SocialLoginProvider3["SLACK"] = "Slack";
  SocialLoginProvider3["SALESFORCE"] = "Salesforce";
  SocialLoginProvider3["LINKEDIN"] = "Linkedin";
  SocialLoginProvider3["OUTREACH"] = "Outreach";
  SocialLoginProvider3["QUICKBOOKS"] = "Quickbooks";
  SocialLoginProvider3["XERO"] = "Xero";
  SocialLoginProvider3["SALESLOFT"] = "Salesloft";
  SocialLoginProvider3["ATLASSIAN"] = "Atlassian";
  SocialLoginProvider3["APPLE"] = "Apple";
  return SocialLoginProvider3;
})(SocialLoginProvider || {});
var SOCIAL_LOGIN_PATHS = {
  ["Google" /* GOOGLE */]: "/google/login",
  ["Github" /* GITHUB */]: "/github/login",
  ["Microsoft" /* MICROSOFT */]: "/microsoft/login",
  ["Slack" /* SLACK */]: "/slack/login",
  ["Salesforce" /* SALESFORCE */]: "/salesforce/login",
  ["Linkedin" /* LINKEDIN */]: "/linkedin/login",
  ["Outreach" /* OUTREACH */]: "/outreach/login",
  ["Quickbooks" /* QUICKBOOKS */]: "/quickbooks/login",
  ["Xero" /* XERO */]: "/xero/login",
  ["Salesloft" /* SALESLOFT */]: "/salesloft/login",
  ["Atlassian" /* ATLASSIAN */]: "/atlassian/login",
  ["Apple" /* APPLE */]: "/apple/login"
};

// src/client.ts
var createFrontendApisClient = ({ authUrl, baseApiUrl }) => {
  const loginWithSocialProvider = (provider) => {
    window.location.href = `${authUrl}/${SOCIAL_LOGIN_PATHS[provider]}`;
  };
  return {
    enableMfa: enableMfa(baseApiUrl),
    disableMfa: disableMfa(baseApiUrl),
    fetchMfaStatusWithNewSecret: fetchMfaStatusWithNewSecret(baseApiUrl),
    updatePassword: updatePassword(baseApiUrl),
    deleteAccount: deleteAccount(baseApiUrl),
    updateUserMetadata: updateUserMetadata(baseApiUrl),
    updateEmail: updateEmail(baseApiUrl),
    fetchOrgMembers: fetchOrgMembers(baseApiUrl),
    fetchPendingOrgInvites: fetchPendingOrgInvites(baseApiUrl),
    fetchExpiredOrgInvites: fetchExpiredOrgInvites(baseApiUrl),
    inviteUserToOrg: inviteUserToOrg(baseApiUrl),
    removeUserFromOrg: removeUserFromOrg(baseApiUrl),
    updateUserRoleInOrg: updateUserRoleInOrg(baseApiUrl),
    revokeUserOrgInvitation: revokeUserOrgInvitation(baseApiUrl),
    updateOrgSettings: updateOrgSettings(baseApiUrl),
    fetchOrgSettings: fetchOrgSettings(baseApiUrl),
    deleteOrg: deleteOrg(baseApiUrl),
    createOrg: createOrg(baseApiUrl),
    fetchPersonalApiKeys: fetchPersonalApiKeys(baseApiUrl),
    createPersonalApiKey: createPersonalApiKey(baseApiUrl),
    fetchOrgApiKeys: fetchOrgApiKeys(baseApiUrl),
    createOrgApiKey: createOrgApiKey(baseApiUrl),
    deleteApiKey: deleteApiKey(baseApiUrl),
    fetchLoginState: fetchLoginState(baseApiUrl),
    emailPasswordLogin: emailPasswordLogin(baseApiUrl),
    resendEmailConfirmation: resendEmailConfirmation(baseApiUrl),
    verifyMfaForLogin: verifyMfaForLogin(baseApiUrl),
    verifyMfaBackupCodeForLogin: verifyMfaBackupCodeForLogin(baseApiUrl),
    sendForgotPasswordEmail: sendForgotPasswordEmail(baseApiUrl),
    fetchJoinableOrgs: fetchJoinableOrgs(baseApiUrl),
    joinOrg: joinOrg(baseApiUrl),
    passwordlessLogin: passwordlessLogin(baseApiUrl),
    loginViaSamlForOrg: loginViaSamlForOrg(baseApiUrl),
    signup: signup(baseApiUrl),
    loginWithSocialProvider
  };
};
export {
  ErrorCode,
  LoginState,
  SocialLoginProvider,
  createFrontendApisClient
};
//# sourceMappingURL=index.mjs.map